<template>
	<div class="flex-column white-bg">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
			class="rounded-t-lg"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#' + tab.type"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="activeTab" touchless>
			<v-tab-item :value="tabs[2].type">
				<v-layout class="white m-auto pa-5 d-flex flex-column">
					<div xs10 md4 lg3>
						<v-text-field
							label="Amount"
							v-model="amountToAdd"
							placeholder="Enter Amount"
							prepend-icon="account_balance_wallet"
							class="text-field-wrapper pt-4"
							:rules="[onlyDigitsRule]"
							maxlength="6"
						></v-text-field>
					</div>
					<div xs12 class="d-flex mt-2">
						<v-btn
							large
							:color="themeInputColor"
							class="white--text btn"
							:loading="isLoading"
							@click="addMoney"
							:disabled="
								!amountToAdd ||
									checkingStatus ||
									/\D/g.test(amountToAdd)
							"
							>Add Money</v-btn
						>
					</div>
				</v-layout>
				<div v-if="checkingStatus" class="pt-4">
					<v-layout class="pb-2 justify-center">
						<v-flex class="d-flex justify-center">
							<v-progress-circular
								indeterminate
								v-bind:size="30"
								color="green pa-2 mr-2"
							></v-progress-circular>
						</v-flex>
					</v-layout>
					<v-layout class="align-center">
						<v-flex xs12 class="text-center">
							<div class="px-3">
								Confirming the payment of your app. Do not press
								any button.
							</div>
						</v-flex>
					</v-layout>
				</div>
			</v-tab-item>
			<v-tab-item :value="tabs[1].type">
				<div
					class="d-flex flex-column pa-5"
					v-if="Object.keys(razorpayDetails).length > 0"
				>
					<h5>
						Transfer to the following bank account to add money in
						{{
							isRummyOptionSelected
								? "Jeet11 Rummy"
								: "Jeet11 Fantasy"
						}}
					</h5>
					<h6>
						Account Number:
						{{ razorpayDetails.accountNumber || "" }}
						<v-icon
							@click="
								copyToClipBoard(razorpayDetails.accountNumber)
							"
							>filter_none</v-icon
						>
					</h6>
					<h6>
						Account IFSC Code:
						{{ razorpayDetails.accountIfsc || "" }}
						<v-icon
							@click="
								copyToClipBoard(razorpayDetails.accountIfsc)
							"
							>filter_none</v-icon
						>
					</h6>
				</div>
				<div class="d-flex flex-column pa-5" v-else>
					<h5>
						Please fill the form to get the account details
					</h5>
					<v-text-field
						label="Name"
						v-model="razorpayCreateDetails.name"
						placeholder="Enter Name"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-text-field
						label="Email"
						v-model="razorpayCreateDetails.email"
						placeholder="Enter Email"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-btn
						large
						:color="themeInputColor"
						class="white--text btn"
						:loading="isCreationLoading"
						@click="createAccount"
						:disabled="
							!(
								razorpayCreateDetails.name &&
								razorpayCreateDetails.email
							)
						"
						>Create Account</v-btn
					>
				</div>
			</v-tab-item>
			<v-tab-item :value="tabs[0].type">
				<div
					class="d-flex flex-column pa-5"
					v-if="Object.keys(paytmVanDetails).length > 0"
				>
					<h5>
						Transfer to the following bank account to add money in
						{{
							isRummyOptionSelected
								? "Jeet11 Rummy"
								: "Jeet11 Fantasy"
						}}
					</h5>
					<h6>
						Account Number:
						{{ paytmVanDetails.vanNumber || "" }}
						<v-icon
							@click="copyToClipBoard(paytmVanDetails.vanNumber)"
							>filter_none</v-icon
						>
					</h6>
					<h6>
						Account IFSC Code:
						{{ paytmVanDetails.vanIfsc || "" }}
						<v-icon
							@click="copyToClipBoard(paytmVanDetails.vanIfsc)"
							>filter_none</v-icon
						>
					</h6>
					<div>
						<div class="d-flex allCenteredChild mt-2">
							<v-btn
								raised
								:color="themeInputColor"
								class="white--text"
								@click="showTpv"
								>Show Allowed Accounts</v-btn
							>
						</div>
						<div class="d-flex allCenteredChild mt-2">
							<v-btn
								raised
								:color="themeInputColor"
								class="white--text"
								@click="addTpv"
								>Add Allowed Accounts</v-btn
							>
						</div>
					</div>
				</div>
				<div class="d-flex flex-column pa-5" v-else>
					<h5>
						Please fill the form to get the account details
					</h5>
					<v-text-field
						label="Name"
						v-model="paytmVanCreateDetails.name"
						placeholder="Enter Name"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-text-field
						label="Email"
						v-model="paytmVanCreateDetails.email"
						placeholder="Enter Email"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-btn
						large
						:color="themeInputColor"
						class="white--text btn"
						:loading="isCreationLoading"
						@click="createAccountPaytm"
						:disabled="
							!(
								paytmVanCreateDetails.name &&
								paytmVanCreateDetails.email
							)
						"
						>Create Account</v-btn
					>
				</div>
			</v-tab-item>
		</v-tabs-items>
		<v-btn flat :color="themeInputColor" class="ma-3" @click="closeModal"
			>Close</v-btn
		>
		<v-dialog width="600px" v-model="showTpvDialog">
			<div class="white pos-rel rounded-lg pa-4">
				<h6 class="text-center">
					List of accounts allowed for transfer
				</h6>
				<div style="height: 60vh; overflow:auto; padding: 6px 12px">
					<v-data-iterator
						:items="sortedTpv"
						:hide-actions="true"
						content-tag="v-layout"
						column
						wrap
					>
						<template v-slot:item="props">
							<v-flex xs12 class="mb-4 mx-auto">
								<v-card>
									<v-list dense>
										<v-list-tile>
											<v-list-tile-content
												>Account
												Number:</v-list-tile-content
											>
											<v-list-tile-content
												class="align-end"
												>{{
													props.item.accountNumber
												}}</v-list-tile-content
											>
										</v-list-tile>
										<v-list-tile>
											<v-list-tile-content
												>Account
												Name:</v-list-tile-content
											>
											<v-list-tile-content
												class="align-end"
												>{{
													props.item.accountHolderName
												}}</v-list-tile-content
											>
										</v-list-tile>
										<v-list-tile>
											<v-list-tile-content
												>Bank Name:</v-list-tile-content
											>
											<v-list-tile-content
												class="align-end"
												>{{
													props.item.bankName
												}}</v-list-tile-content
											>
										</v-list-tile>
										<v-list-tile>
											<v-list-tile-content
												>IFSC Code:</v-list-tile-content
											>
											<v-list-tile-content
												class="align-end"
												>{{
													props.item.ifscCode
												}}</v-list-tile-content
											>
										</v-list-tile>
										<v-list-tile>
											<v-list-tile-content
												class="text-center font-weight-bold fz-16 allCenteredChild"
												>{{
													props.item.isActive
														? "Active"
														: "Inactive"
												}}</v-list-tile-content
											>
											<v-list-tile-content
												v-if="props.item.isActive"
												class="align-end"
											>
												<v-btn
													@click="
														toggleActiveStatus(
															props.item
														)
													"
													flat
												>
													Mark as Inactive
												</v-btn>
											</v-list-tile-content>
										</v-list-tile>
									</v-list>
								</v-card>
							</v-flex>
						</template>
					</v-data-iterator>
				</div>
				<v-btn flat :color="themeInputColor" @click="closeShowTpvDialog"
					>Close</v-btn
				>
				<v-btn flat :color="themeInputColor" @click="addTpv"
					>Add Account</v-btn
				>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="addTpvDialog">
			<div class="white pos-rel rounded-lg">
				<div class="d-flex flex-column pa-5">
					<h5>
						Please fill the form to add the account for transfers
					</h5>
					<v-text-field
						label="Account Number"
						v-model="addTpvDetails.accountNumber"
						placeholder="Account Number"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-text-field
						label="Account Name"
						v-model="addTpvDetails.accountHolderName"
						placeholder="Account Name"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-text-field
						label="Bank Name"
						v-model="addTpvDetails.bankName"
						placeholder="Bank Name"
						class="text-field-wrapper pt-4"
					></v-text-field>
					<v-text-field
						label="IFSC Code"
						v-model="addTpvDetails.ifscCode"
						placeholder="IFSC Code"
						class="text-field-wrapper pt-4"
						@keyup="uppercase"
					></v-text-field>
					<v-btn
						large
						:color="themeInputColor"
						class="white--text btn"
						:loading="addTpvLoading"
						@click="submitTpvDetails"
						:disabled="
							!(
								addTpvDetails.accountNumber &&
								addTpvDetails.accountHolderName &&
								addTpvDetails.bankName &&
								addTpvDetails.ifscCode
							)
						"
						>Add Account</v-btn
					>
				</div>
				<v-btn
					flat
					:color="themeInputColor"
					class="ma-3"
					@click="closeTpvDialog"
					>Close</v-btn
				>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { _onlyDigitsRule } from "@/utils";
import { SHOW_ALERT } from "@/store/action-types";
export default {
	name: "AddMoney",
	props: [
		"isLoading",
		"checkingStatus",
		"razorpayDetails",
		"isCreationLoading",
		"isRummyOptionSelected",
		"themeInputColor",
		"paytmVanDetails",
		"addTpvLoading"
	],
	data() {
		return {
			amountToAdd: null,
			activeTab: "paytmVan",
			tabs: [
				{ name: "Bank Transfer - Paytm", type: "paytmVan" },
				{ name: "Bank Transfer - Razorpay", type: "bank" },
				{ name: "Pay Using UPI", type: "upi" }
			],
			razorpayCreateDetails: {
				name: "",
				email: ""
			},
			paytmVanCreateDetails: {
				name: "",
				email: ""
			},
			headers: [
				{
					text: "Account Number",
					value: "accountNumber",
					align: "center",
					sortable: false
				},
				{
					text: "Account Name",
					value: "accountHolderName",
					align: "center",
					sortable: false
				},
				{
					text: "Bank Name",
					value: "bankName",
					align: "center",
					sortable: false
				},
				{
					text: "IFSC Code",
					value: "ifscCode",
					align: "center",
					sortable: false
				}
			],
			addTpvDialog: false,
			addTpvDetails: {
				accountNumber: "",
				active: true,
				accountHolderName: "",
				bankName: "",
				ifscCode: ""
			},
			onlyDigitsRule: _onlyDigitsRule,
			showTpvDialog: false
		};
	},
	computed: {
		sortedTpv() {
			return (this.paytmVanDetails.tpvList || []).slice().sort((a, b) => {
				if (a.isActive && !b.isActive) {
					return -1;
				}
				if (!a.isActive && b.isActive) {
					return 1;
				}
				return 0;
			});
		}
	},
	mounted() {
		// Disable bank transfer for Rummy
		if (this.isRummyOptionSelected) {
			this.$set(this.tabs, 1, {});
		}
	},
	methods: {
		createAccount() {
			this.$emit("CREATE_ACCOUNT", this.razorpayCreateDetails);
		},
		closeModal() {
			this.$emit("CLOSE_MODAL");
		},
		addMoney() {
			this.$emit(
				"ADD_MONEY",
				Math.round(Number(this.amountToAdd) * 100) / 100
			);
		},
		copyToClipBoard(text) {
			try {
				let input = document.createElement("input");
				input.setAttribute("value", text);
				document.body.appendChild(input);
				input.select();
				document.execCommand("copy");
				document.body.removeChild(input);
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Copied successfully!"
				});
			} catch (e) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Error occured while copying"
				});
			}
		},
		createAccountPaytm() {
			this.$emit("CREATE_ACCOUNT_PAYTM", this.paytmVanCreateDetails);
		},
		addTpv() {
			this.addTpvDialog = true;
			this.addTpvDetails = {
				accountNumber: "",
				active: true,
				accountHolderName: "",
				bankName: "",
				ifscCode: ""
			};
		},
		closeTpvDialog() {
			this.addTpvDialog = false;
		},
		submitTpvDetails() {
			this.$emit("ADD_TPV", this.addTpvDetails);
			this.addTpvDialog = false;
		},
		showTpv() {
			this.showTpvDialog = true;
		},
		closeShowTpvDialog() {
			this.showTpvDialog = false;
		},
		toggleActiveStatus(data) {
			const {
				accountNumber = "",
				accountHolderName = "",
				bankName = "",
				ifscCode = ""
			} = data;
			this.addTpvDetails = {
				accountNumber,
				active: false,
				accountHolderName,
				bankName,
				ifscCode
			};
			this.submitTpvDetails();
		},
		uppercase() {
			this.addTpvDetails.ifscCode = this.addTpvDetails.ifscCode.toUpperCase();
		}
	}
};
</script>
<style scoped>
.rounded-t-lg {
	border-radius: 16px 16px 0px 0px;
}
</style>
